import { request } from '@umijs/max';

const createRequest =
  <DefaultT = any>(
    method: string,
    defaultHeaders: Record<string, string> = {},
  ) =>
  async <T = DefaultT>(
    url: string,
    options?: { [key: string]: any },
  ): Promise<T> => {
    return await request<T>(url, {
      method,
      headers: {
        ...defaultHeaders,
        ...options?.headers,
      },
      ...options,
    });
  };

export const get = createRequest('GET');
export const post = createRequest('POST');
export const postForm = createRequest('POST', {
  'Content-Type': 'multipart/form-data',
});
export const put = createRequest('PUT');
export const putForm = createRequest('PUT', {
  'Content-Type': 'multipart/form-data',
});
export const remove = createRequest('DELETE');
